import React, { useState,useEffect } from "react";
import Autosuggest from 'react-autosuggest';
import "./PromotionalMessages.css";
import httpClient from "../../http-client/client";
export default function PromotionalMessages(params) {
    const [number,setNumber]=useState("");
    const [message,setMessage]=useState("");
    const [select,setSelect]=useState("");
    const [url,setUrl]=useState("");
 
      async function fetchData() {
        await httpClient.post("/refer/sendpromotionmessage",{number,message});

       setNumber("");
       setMessage("");
      }
      async function fetchNumber() {
        setNumber("");
        await httpClient.post("/refer/getpromotionnumber",{url,select}).then((res)=>{
          console.log(res.data)
          setNumber(res.data);
        });

       
      }
    
      const handleSubmit = e => {
        e.preventDefault()
        fetchData()
      }
      const handleSelect = e => {
       setSelect(e.target.value);
      }
    return(
        <>
     
     <div class="form1">
     <div className="row"  style={{marginLeft:"7%"}}>
     <div className="radio">
          <label className="label1">
            <input
              type="radio"
              value="URL"
              checked={select === "URL"}
              onChange={handleSelect}
            />
            URL
          </label>
        </div>
        <div className="radio" style={{paddingLeft:"10px"}}>
          <label className="label1">
            <input
              type="radio"
              value="Text"
              checked={select === "Text"}
              onChange={handleSelect}
            />
            Text
          </label>
        </div>
        </div>
     <div className="row">
       <label className="label1" for="number"><b>Page URL:</b></label>
    <textarea id="sad"  placeholder="Enter URL " value={url} onChange={(event)=>{setUrl(event.target.value)}} required />
     
        </div>
        <div className="col">
     <button onClick={fetchNumber}  class="btn1">Start</button>
     </div></div>
       <form onSubmit={handleSubmit} className="form1">
       <div class="formfield">
       
       <div className="row">
       <label className="label1" for="number"><b>Numbers:</b></label>
    <textarea id="sad"  placeholder="Enter Numbers" value={number} onChange={(event)=>{setNumber(event.target.value)}} required />
     
        </div>
        <div className="row">
        <label className="label1" for="message"><b>Message:</b></label>
    <textarea placeholder="Enter Message" value={message} onChange={(event)=>{setMessage(event.target.value)}} required/>
     
        </div>
        </div>
        <div className="col">
     <button type="submit" class="btn1">Submit</button>
     </div>
       
      </form>
     
        </>
    )
}